// extracted by mini-css-extract-plugin
export var container = "meal-modal-module--container--d539e";
export var content = "meal-modal-module--content--c2c84";
export var description = "meal-modal-module--description--38db9";
export var editButton = "meal-modal-module--edit-button--2216d";
export var header = "meal-modal-module--header--981cf";
export var img = "meal-modal-module--img--db9e8";
export var loader = "meal-modal-module--loader--af603";
export var modal = "meal-modal-module--modal--c2e20";
export var ratioClass = "meal-modal-module--ratio-class--2a269";
export var separator = "meal-modal-module--separator--1e58c";
export var subtitle = "meal-modal-module--subtitle--2f29a";
export var title = "meal-modal-module--title--2857e";